import React, { Fragment, useEffect } from "react";
import { Modal } from "react-bootstrap";
import SelectComponent from "../../../components/SelectComponent";
import style from "../../../scss/modal.module.scss";
import { editarconteo } from "../../../Api/ApiConteo";
import { obtenerMensajeError } from "../../../utils/mensajeError";
const ModalconteoComponent = (props) => {
  const {
    setShow,
    show,
    setSelectedOptionlugar,
    selectedOptionlugar,
    selectedOptionmesa,
    setSelectedOptionmesa,
    id,
    setMostraralert,
    setcolorAlert,
    setAlerta,
    votos,
    setVotos,
    setSelectecandidato,
    candidato,
    datos,
    setconteo,
    opcionesCandidato,
    opcionesLugar,
    opcionesMesaDe,
    onCambio,
  } = props;
  const handleClose = () => setShow(false);

  // las mesas dependen del lugar: al cambiarlo se vuelve a elegir la mesa
  const cambiarLugar = (valor) => {
    setSelectedOptionlugar(valor);
    setSelectedOptionmesa(null);
  };
  const mostrarAlerta = (color, mensaje) => {
    setMostraralert(true);
    setcolorAlert(color);
    setAlerta(mensaje);
    setTimeout(() => {
      setMostraralert(false);
    }, 3000);
  };
  const editarCId = () => {
    editarconteo(
      id,
      candidato,
      selectedOptionlugar,
      selectedOptionmesa,
      votos,
    )
      .then((response) => {
        mostrarAlerta("alert-success", response.msg);
        setShow(false);
        onCambio?.();
      })
      .catch((error) => {
        mostrarAlerta("alert-danger", obtenerMensajeError(error));
        setShow(false);
      });
  };

  return (
    <Fragment>
      <>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Editar Conteo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-center" >
              <div className={style.Registro}>
                <form className={style.formulario}>
                  <div className="row gy-4">
                    <div className="col-12 col-md-6">
                      <SelectComponent
                        etiqueta="Candidato"
                        opciones={opcionesCandidato}
                        onCambiar={setSelectecandidato}
                        valor={candidato}
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <SelectComponent
                        etiqueta="Lugar"
                        opciones={opcionesLugar}
                        onCambiar={cambiarLugar}
                        valor={selectedOptionlugar}
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <SelectComponent
                        etiqueta="Mesa"
                        opciones={opcionesMesaDe(selectedOptionlugar)}
                        onCambiar={setSelectedOptionmesa}
                        valor={selectedOptionmesa}
                        deshabilitado={!selectedOptionlugar}
                        placeholder={selectedOptionlugar ? "Seleccionar mesa" : "Primero elige el lugar"}
                      />
                    </div>
                    <div className="col-12 col-md-6">
                      <label htmlFor="votos" className="text-white">
                        Cantidad de votos:
                      </label>
                      <input
                        type="number"
                        id="votos"
                        className="form-control"
                        value={votos}
                        onChange={(e) => setVotos(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 mt-3">
                    <button
                      type="button"
                      className="btn btn-primary me-6"
                      onClick={() => {
                        editarCId();
                      }}
                    >
                      Guardar Cambios
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    </Fragment>
  );
};
export default ModalconteoComponent;
